import React, { useEffect, useState } from 'react';
import "./SatDesignerSideBar.scss";

type TreeNodeProps = {
    node: any;
    iconDisplayerFunc: (label: string) => React.ReactNode;
    level?: number;
    isLastChild?: boolean;
    addPayloadFunc?: (label: string) => void;
    setSelectedSensor?: (sensor: any) => void;
    setSelectedSensorHeader?: (boolean: any) => void;
    isParentLast?: boolean[];
    selectedNodeLabel?: string | null;
    onSelect?: (label: string) => void;
    onToggleVisibility?: (label: string) => void;
    meshVisibilityMap: Record<string, boolean>;
};
export const TreeNode: React.FC<TreeNodeProps> = ({
    node,
    iconDisplayerFunc,
    level = 1,
    isLastChild = false,
    addPayloadFunc,
    setSelectedSensor,
    setSelectedSensorHeader,
    selectedNodeLabel,
    onSelect,
    onToggleVisibility,
    meshVisibilityMap
}) => {
    const [expanded, setExpanded] = useState(false);
    const [showSensor, setShowSensor] = useState(true);
    const hasChildren = node.children && node.children.length > 0;
    const isSelected = selectedNodeLabel === node.label;
    const ulClassName = level === 2 ? 'second-level' : level === 3 ? 'third-level' : ''
    const meshName = node.label;
    
    // const isLeaf = !hasChildren;
    // const isVisible = isLeaf
    //     ? meshVisibilityMap[node.label] ?? true
    //     : node.children.every(child => meshVisibilityMap[child.label] !== false);
    
        const handleLeafClick = () => {
        if (!hasChildren) {
            addPayloadFunc?.(node.label);
            setSelectedSensor?.([{ node }]);
            setSelectedSensorHeader?.(false);
        }
    };

    const handleIntermediateClick = () => {
        if (hasChildren && level === 2) {
            const sensorItems = node?.children.map((child) => ({
                name: child.label,
                value: child.value
            }));
            addPayloadFunc?.(node.label);
            setSelectedSensor?.(sensorItems);
            setSelectedSensorHeader?.(node.label);
        }
    };

    const handleNodeClick = () => {
        onSelect?.(node.label);
        if (hasChildren && level === 2) {
            handleIntermediateClick();
        } else if (!hasChildren) {
            handleLeafClick();
        }
    };
    
    const handleToggleClick = () => {
        const newVisibility = !showSensor;
        setShowSensor(newVisibility);
        // Toggle current node
        onToggleVisibility?.(meshName);
        onToggleVisibility?.("sensor-mesh-group");
        // If expanded, toggle all children too
        if (expanded && hasChildren) {
            node.children.forEach(child => {
                onToggleVisibility?.(child.label);
            });
        }
    };

    useEffect(()=>{
        if (meshVisibilityMap){
            if (meshVisibilityMap[node.label] === true){
                setShowSensor(true)
            } else if (meshVisibilityMap[node.label] === false){
                setShowSensor(false)
            }
        }
    }, [meshVisibilityMap])
   
    return (
        <li className={`tree-item ${isLastChild ? 'last-child' : ''} ${expanded ? 'expanded' : ''}`}>
            <div className={`tree-node ${isSelected ? 'selected' : ''}`} 
                    onClick={handleNodeClick}>
                <div
                    className={`node-container`}
                    style={{ paddingLeft: `${(level - 1) * 12}px` }}
                >
                    {hasChildren && (
                        <span
                            style={{ cursor: 'pointer', scale: '1.3' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(!expanded);
                            }}
                        >
                            {expanded ? '▾' : '▸'}
                        </span>
                    )}

                    <span style={{ scale: '1.3' }}>{iconDisplayerFunc("Sensors")}</span>

                    <span
                        className="tree-node-label"
                        title={node.label}
                    >
                        {node.label}
                    </span>
                </div>
                {level !== 1 && (
                    <div className='icon-container'>
                        <span style={{ display: 'flex', alignItems: 'center' }} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                handleToggleClick()
                            }}>
                            {showSensor ? <i className='fe fe-eye eye__icon' /> : <i className='fe fe-eye-off eye__icon' />}
                        </span>    
                    </div>
                )}
            </div>

            {hasChildren && expanded && (
                <ul className={`${ulClassName} ${isLastChild ? 'last-child-group' : ''}`}>
                    {node.children.map((child, index) => {
                        const isLast = index === node.children.length - 1;

                        return (
                            <TreeNode
                                key={index}
                                node={child}
                                iconDisplayerFunc={iconDisplayerFunc}
                                level={level + 1}
                                isLastChild={isLast}
                                addPayloadFunc={addPayloadFunc}
                                setSelectedSensor={setSelectedSensor}
                                setSelectedSensorHeader={setSelectedSensorHeader}
                                selectedNodeLabel={selectedNodeLabel}
                                onSelect={onSelect}
                                onToggleVisibility={onToggleVisibility}
                                meshVisibilityMap={meshVisibilityMap}
                            />
                        );
                    })}
                </ul>
            )}
        </li>
    );
};

export default TreeNode;